import { render, staticRenderFns } from "./beauty.vue?vue&type=template&id=4297e7df&scoped=true"
import script from "./beauty.vue?vue&type=script&lang=js"
export * from "./beauty.vue?vue&type=script&lang=js"
import style0 from "./beauty.vue?vue&type=style&index=0&id=4297e7df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297e7df",
  null
  
)

export default component.exports